//drei's <Html> writes a computed z-index straight onto the element's inline style, using
//zIndexRange which defaults to [16777271, 0]. That beats any modal/dialog z-index in the
//app, so the 3D dimension labels and floating buttons render on top of open dialogs.
//Capping the range keeps the overlays above the canvas but below modals (z-[9999999]).
export const HTML_OVERLAY_Z_INDEX_RANGE = [1000, 0];
